'use strict';

var dateFns = require('date-fns');

const getUnionIntervals = (a, b) => {
  const result = [];
  if (!dateFns.areIntervalsOverlapping(a, b, { inclusive: true })) {
    result.push(a, b);
  } else {
    result.push({
      start: dateFns.min([a.start, b.start]).getTime(),
      end: dateFns.max([a.end, b.end]).getTime()
    });
  }
  return result;
};

module.exports = getUnionIntervals;
//# sourceMappingURL=getUnionIntervals.cjs.map
